import React from 'react';
import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import ResizeService from './../../../service/resize';
import TrackStepsPanel from './../../panel/core/track-steps';
import theme from './../../theme';

export const AddSeekViewPrompt = ({
    children,
    steps,
    currentStep,
    allowAccess
}) => {
    const getAddSeekStepPanelStyle = () => theme.addSeekStepPanelStyle(theme);
    const [ addSeekStepPanelStyle, setAddSeekStepPanelStyle] = useState(getAddSeekStepPanelStyle());
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setAddSeekStepPanelStyle(getAddSeekStepPanelStyle());
    });
    useEffect(resizeEffect);
    return (
        <section>
            {
                !allowAccess && 
                <div style={{ 
                    ...theme.getAbstractCheckFieldContainer(theme),
                    ...theme.getReportedIssueUnseenStyle(theme)
                }}>
                    <p>
                        You must pay all your unpaid fees before you can add more seeks.  
                        &nbsp;
                        <NavLink 
                            style={{ ...theme.getGeneralTextLinkStyle(theme) }} 
                            to="/profile/fees"
                        >
                            Pay Fees Here
                        </NavLink>
                    </p>
                </div>
            }  
            <TrackStepsPanel list={steps} currentStep={currentStep} />
            <div style={addSeekStepPanelStyle}>
                { children }
            </div>
        </section>
        
    );

};
